import { Radio, RadioProps } from '@mui/material'
import withStyles from '@mui/styles/withStyles'
import React from 'react'
import { $Gray90, $primaryColor } from '@Styles/colors'

export const BaseRadio = withStyles({
    root: {
        color: $Gray90,
        '&$checked': {
            color: $primaryColor,
        },
    },
    checked: {},
})((props: RadioProps) => <Radio color="default" {...props} />)
